import useUpdateQueues from "@Hooks/useUpdateQueues";
import { Button, Col, Modal, Row } from "antd";

import EmergencyImage from "@Assets/icons/alarm.svg";
import "./QueueInformation.css";

import TagStatus from "@Components/V2/TagStatus";
import { SHORTCUT_KEYS } from "@Constants/shortcut-keys";
import useGetAllActiveQueue from "@Hooks/queries/useGetAllActiveQueue";
import useHotkeys from "@Hooks/useHotKeys";
import useSpeechVoice from "@Hooks/useSpeechVoice";
import { CALL_TYPE_QUEUE } from "../../Constants";
import React from "react";

const QueueInformation = ({ shiftData }) => {
  const { selectedVoice, isReady } = useSpeechVoice("id");

  const allActiveQueue = useGetAllActiveQueue();
  const updateQueues = useUpdateQueues();

  const patientCurrentQueue = allActiveQueue?.data?.queue?.find(
    (order) => order.queue_number === allActiveQueue?.data?.current_queue,
  );

  const patientNextQueue = allActiveQueue?.data?.queue?.find(
    (order) => order.queue_number === allActiveQueue?.data?.next_queue,
  );
  const emergencyPatient = allActiveQueue?.data?.queue?.find(
    (order) => order.queue_status.id === 8,
  );

  const onClickCheckPatient = () => {
    const queue = allActiveQueue.data.queue.find(
      (order) => order.queue_number === allActiveQueue.data?.current_queue,
    );

    if (queue) {
      const queueId = queue?.id;
      updateQueues.onCheckPatient(queueId);
      return;
    }
    return Modal.error({
      title: "Gagal!",
      content: "Tidak Ada Antrian Selanjutnya",
    });
  };

  const onClickPassedPatient = () => {
    const queue = allActiveQueue.data.queue.find(
      (order) => order.queue_status.id === 3,
    );

    if (queue) {
      const queueId = queue?.id;
      updateQueues.onPassesPatient(queueId);
      return;
    }
    return Modal.error({
      title: "Gagal!",
      content: "Tidak Ada Antrian Selanjutnya",
    });
  };

  const onCallQueue = (type) => {
    let text;

    if (type === CALL_TYPE_QUEUE.CURRENT) {
      text = `Panggilan untuk nomor antrian ${allActiveQueue?.data?.current_queue}, harap masuk ke ruang periksa`;
    } else {
      text = `Antrian selanjutnya nomor ${allActiveQueue?.data?.next_queue}, harap bersiap-siap`;
    }

    // Buat objek utterance
    const utterance = new SpeechSynthesisUtterance(text);

    if (isReady && selectedVoice) {
      utterance.voice = selectedVoice;
    }

    // Atur opsi suara
    utterance.rate = 0.7; // kecepatan bicara (0.1 - 10)
    utterance.pitch = 1; // nada suara (0 - 2)
    utterance.volume = 1; // volume (0 - 1)

    // Jalankan speech
    window.speechSynthesis.speak(utterance);
  };

  useHotkeys([
    [
      SHORTCUT_KEYS.CALL_CURRENT_QUEUE,
      !allActiveQueue?.data?.current_queue
        ? () => {} // there is not queue
        : () => onCallQueue(CALL_TYPE_QUEUE.CURRENT),
    ],
  ]);
  useHotkeys([
    [
      SHORTCUT_KEYS.CALL_NEXT_QUEUE,
      !allActiveQueue?.data?.next_queue
        ? () => {} // there is not queue
        : () => onCallQueue(CALL_TYPE_QUEUE.NEXT),
    ],
  ]);

  console.log("🚀 allActiveQueue >>", allActiveQueue)

  const isPassesCurrentQueue = patientCurrentQueue?.is_passed;
  const isPassesNextQueue = patientNextQueue?.is_passed;

  return (
    <Row gutter={[16, 16]}>
      <Col xs={{ span: 24 }} lg={{ span: 17 }}>
        <div className="current-queue-wrapper">
          {emergencyPatient &&
            [1, 2].map((item) => (
              <img
                key={item}
                src={EmergencyImage}
                alt="EMERGENCY"
                className={`current-emergency-image-${item}`}
              />
            ))}

          <p className="antrian-queue-description">
            Antrian Shft maksimal {shiftData?.registration_limit || 0} orang
          </p>
          <p className="queue-info-title">Nomor Antrian Saat Ini</p>
          <p className="queue-number-primary">
            {allActiveQueue?.data?.current_queue || 0}
            <span className="queue-number-secondary">
              /{allActiveQueue?.data?.total_queue || 0} Antrian
            </span>
          </p>

          {patientCurrentQueue && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="current-patient-name-wrapper">
                <p className="current-patient-name">
                  {patientCurrentQueue?.child?.fullname}
                </p>
              </div>
              {isPassesCurrentQueue && (
                <div
                  style={{
                    background: "#FFECED",
                    borderRadius: "100px",
                    padding: "4px 10px",
                    width: "fit-content",
                    margin: "0 auto",
                    marginTop: 8,
                  }}
                >
                  <TagStatus text="Passed" />
                </div>
              )}
            </div>
          )}

          <div className="current-btn-wrapper">
            {emergencyPatient && (
              <Button type="primary" size="large" danger>
                Darurat
              </Button>
            )}

            {patientCurrentQueue &&
              patientCurrentQueue?.queue_status_id === 3 && (
                <>
                  <Button
                    danger
                    type="primary"
                    size="large"
                    onClick={onClickPassedPatient}
                    loading={updateQueues.isLoading}
                    hidden={emergencyPatient}
                  >
                    Lewati Antrian
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    onClick={onClickCheckPatient}
                    loading={updateQueues.isLoading}
                    hidden={emergencyPatient}
                  >
                    Periksa
                  </Button>
                </>
              )}

            {patientCurrentQueue &&
              patientCurrentQueue?.queue_status_id === 4 && (
                <Button
                  type="primary"
                  size="large"
                  disabled
                  hidden={emergencyPatient}
                >
                  Sedang diperiksa
                </Button>
              )}

            <Button
              type="primary"
              size="large"
              onClick={() => onCallQueue(CALL_TYPE_QUEUE.CURRENT)}
              disabled={!allActiveQueue?.data?.current_queue}
            >
              Panggil
            </Button>
          </div>
        </div>
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 7 }}>
        <div className="next-queue-wrapper">
          <p className="queue-info-title">
            Antrian
            <br />
            Selanjutnya
          </p>
          <p className="queue-number-primary">
            {allActiveQueue?.data?.next_queue || 0}
          </p>
          {patientCurrentQueue && patientNextQueue && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="next-patient-name-wrapper">
                <p className="next-patient-name">
                  {patientNextQueue?.child?.fullname}
                </p>
              </div>
              {isPassesNextQueue && (
                <div
                  style={{
                    background: "#FFECED",
                    borderRadius: "100px",
                    padding: "4px 10px",
                    width: "fit-content",
                    margin: "0 auto",
                  }}
                >
                  <TagStatus text="Passed" />
                </div>
              )}
            </div>
          )}
          <div className="next-btn-wrapper">
            <Button
              type="primary"
              size="large"
              onClick={() => onCallQueue(CALL_TYPE_QUEUE.NEXT)}
              disabled={!allActiveQueue?.data?.next_queue}
            >
              Panggil
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default QueueInformation;
